<template>
  <div class="page-container">
    <van-cell-group v-if="data">
      <van-cell>
        <template slot="title">
          <van-cell>学生姓名：{{ data.fcustname }}</van-cell>
          <van-cell>年级：{{ data.fgrade }}</van-cell>
          <van-cell>上课校区：{{ data.forgname }}</van-cell>
          <van-cell>上课形式：{{ data.fclasstype }}</van-cell>
          <van-cell v-if="data1 && data1.length > 0">
            报名课程：
            <div v-for="(item, index) in data1" :key="index">
              <span>{{ item.fname }}</span>
              <span>课时：{{ item.ftotalcount }}课时</span>
            </div>
          </van-cell>
          <van-cell>指导老师：{{ data.fzdlsname }}</van-cell>
          <van-cell>咨询顾问：{{ data.fzxgw }}</van-cell>
          <van-cell v-if="data2 && data2.length > 0">
            <template>
              授课老师：
              <van-cell v-for="item in data2" :key="item.fid">
                <template slot="title">
                  <van-cell :title="item.fsubjectname" :value="item.fteachername" />
                </template>
              </van-cell>
            </template>
          </van-cell>
          <van-cell>
            基本情况：
            <van-field :value="data.fbasicinformation"
              autosize type="textarea" />
          </van-cell>
          <van-cell>
            学生特点和相关经历：
            <van-field :value="data.features" autosize type="textarea" />
          </van-cell>
          <van-cell>
            可排课时间：
            <van-field :value="ffreetimetext" autosize type="textarea" />
          </van-cell>
          <van-cell>
            后续规划：
            <van-field :value="fplantext" autosize type="textarea" />
          </van-cell>
          <van-cell>
            备注：
            <van-field :value="data.fremark" autosize type="textarea" />
          </van-cell>
        </template>
        <!-- <template slot="value">内容</template>
        <template slot="label">描述信息</template> -->
      </van-cell>
    </van-cell-group>


    <van-button class="bottom-btn" type="info" block @click="handleSubmit">
      分配授课老师
    </van-button>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
// import * as dd from 'dingtalk-jsapi'
// import { getUserInfo } from '@/libs/utils'

// import { unSelect } from '@/api/public'
// import * as dd from 'dingtalk-jsapi'
import { select } from '@/api/public'

import {
  Toast,
  Button,
  Tabbar,
  TabbarItem, Cell, CellGroup
} from 'vant';
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  name: 'detail',
  components: {
  },
  computed: {
    getFdate() {
      return moment(this.fdate).format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.fid = this.$route.query.id
    this.loaddata()
  },
  methods: {
    onCancel() {
      this.searchText = null
    },
    handleSubmit() {
      this.$router.push({ name: 'edit', query: { id: this.fid } })
    },
    loaddata() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let params = {

      }
      params.fstudentid = this.fid
      params.proc_name = 'sp_stu_document_data'
      select(params).then(res => {
        console.log(res)
        this.data1 = res.data.map.list1
        this.ffreetimetext = res.data.map.list && res.data.map.list[0].ffreetimetext
        this.fplantext = res.data.map.list && res.data.map.list[0].fplantext
        Toast.clear()
      }).catch(err => {
        console.log(err)
        Toast.clear()
      })
      let _params = {

      }
      _params.fstudentid = this.fid
      _params.fprojectid = ''
      _params.proc_name = 'sp_stu_assignment_info'
      select(_params).then(res => {
        console.log(res)
        this.data = res.data.map.list && res.data.map.list.length > 0 ? res.data.map.list[0] : null
        this.data2 = res.data.map.list1
        this.$store.commit('setCurrentTeacher', res.data.map.list1)
        Toast.clear()
      }).catch(err => {
        console.log(err)
        Toast.clear()
      })
    },
  },
  data() {
    return {
      ffreetimetext:null,
      fplantext:null,
      searchText: null,
      fid: null,
      data: null,
      data1: null,
      data2: null,
    };
  },
}
</script>

<style lang="less" scoped>
.page-container {
  padding: 10px;
  font-weight: bold;
}

.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* 避免被其他元素覆盖 */
  z-index: 100;
}
</style>
